<template>
  <div class="checkout-builder-elements-modal">
    <div class="tab-title">
      <div class="title-cell">
        <bp-icon size="20" icon="fa fa-icons" />
        <h2>Elementos</h2>
      </div>
    </div>

    <div class="elements-container">
      <button
        v-for="element in allowedElements"
        class="element-cell"
        :key="element.type"
        @click="addElement(element.type)"
      >
        <div class="d-flex" v-if="Array.isArray(element.icon)">
          <bp-icon
            class="text-neutral-900"
            v-for="icon in element.icon"
            size="38"
            weight="200"
            :key="icon"
            :icon="icon"
          />
        </div>
        <bp-icon
          v-else
          size="38"
          weight="200"
          class="text-neutral-900"
          :icon="element.icon"
        />

        <div class="text-neutral-600">{{ element.label }}</div>
      </button>
    </div>
  </div>
</template>

<script>
import elements from "./elements";
export default {
  props: {
    allow: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    allowedElements() {
      return elements.filter(e => this.allow.includes(e.type));
    }
  },
  methods: {
    addElement(type) {
      this.$emit("close");
      this.$emit("add-element", type);
    }
  }
};
</script>

<style lang="scss" scoped>
.checkout-builder-elements-modal {
  .tab-title {
    display: flex;
    padding: 16px 0;
    align-items: center;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
    background: var(--Surface-Cumulative-plus8, rgba(255, 255, 255, 0.32));
  }

  .title-cell {
    align-items: center;
    padding: 12px 20px;
    display: flex;
    gap: 8px;
  }

  .elements-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin: 24px 0;
  }

  .element-cell {
    gap: 12px;
    padding: 12px;
    display: flex;
    user-select: none;
    border-radius: 4px;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    background: var(--Surface-Cumulative-plus8, rgba(255, 255, 255, 0.32));
    border: 1px solid var(--Semantic-Neutral-048, rgba(215, 215, 215, 0.48));
  }
}
</style>
